import HackerNews from "./components/HackerNews";

function App() {
  return <HackerNews />;
}

export default App;
